export default "__VITE_ASSET__xdIgALqN__"